import { KeyIcon } from "lucide-react";
import CommonEmptyState from "../common/empty-state";

export default function TenantsEmptyState() {
  return (
    <CommonEmptyState
      icon={<KeyIcon />}
      title="No Tenants yet"
      descrption="This property has no tenants yet."
    />
  );
}
